import Home from './components/Home/Home';

import './App.scss';

export type AppProps = {
  dir: string | 'ltr' | 'rtl';
  rtl: boolean;
}

function App(props: AppProps) {
  return (
    <div className="frame-width mobily-to-top" style={{ marginTop: "-3rem" }}>
      <main className={props.rtl ? `dividend-payment-enquiry app-right container` : `dividend-payment-enquiry app-left container`} id="dividendPaymentEnquiry">
        <Home {...props} />
      </main>
    </div>
  );
}

export default App;
